module.exports = __webpack_public_path__ + "static/media/header.02e31ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/psy/header.jpg
// module id = 728
// module chunks = 1